const archiData = [
  { name: "Compteurs", id: "accountmeters" },
  { name: "Evènements", id: "siteevents" },
  ];

  const billData = [  
    { name: "AVOB - Multi énergie - CSV - Import avec template AVOB", id: "multienergyavobcsv" },
    { name: "AVOB - Données véhicules - CSV - Import avec template AVOB", id: "vehicledataavobcsv" },
    { name: "AVOB - Données MBM - CSV - Import avec template AVOB", id: "elementdatacsv" },
    { name: "Fréquentation - XLSX - Import", id: "frequentationxlsx" },
    { name: "Caleo - Eau - PDF", id: "caleowaterpdf" },
    { name: "Caleo - Gaz - PDF", id: "caleogazpdf" },
    { name: "Concordia - Chaleur - PDF", id: "concordiaheatpdf" },
    { name: "CYO - Eau - PDF", id: "cyowaterpdf" },
    { name: "Eau de Paris - Eau - PDF", id: "eaudepariswaterpdf" },
    { name: "Eau de Rouen Métropole - Eau - PDF", id: "eaurouenmetropole" },
    { name: "EDF - Electricité - CSV - Import dialège", id: "dialege" },
    { name: "EDF - Electricité - CSV - 2023", id: "edfexportcsv" },
    { name: "EDF - Electricité - PDF", id: "edfelectricitypdf" },
    { name: "EDF - Gaz - CSV - 2023", id: "edfexportgazcsv" },
    { name: "EDF - Gaz - PDF", id: "edfgazpdf" },
    { name: "ENEDIS - Electricité - CSV - Import index", id: "enedisdatafile" },
    { name: "ENEDIS - Electricité - CSV - 2024", id: "enedisdatafile2024" },
    { name: "ENEDIS - Electricité - PDF - Facture CARD", id: "enediscard" },
    { name: "ENERCOOP C5-C4 - Electricité - XLSX", id: "enercoopc5c4electricityxlsx" },
    { name: "ENERGERM - Electricité - PDF", id: "energermelectricitypdf" },
    { name: "ENERGERM - Gaz - PDF", id: "energermgazpdf" },
    { name: "Engie - Gaz - PDF", id: "engiegazpdf" },
    { name: "Gaz de Bordeaux - Gaz - CSV - Import", id: "gdbgascsv" },
    { name: "Gaz de Bordeaux - Gaz - PDF - Piece jointe de facture", id: "gdbgazmultisitebilllink" },
    { name: "Gazena - Electricité - PDF - Import", id: "gazenaelectricitypdf" },
    { name: "Gedia - Gaz - PDF - Import", id: "gediagazpdf" },
    { name: "GRDF - Gaz - CSV - Import", id: "grdfdatafile" },
    { name: "Le Mans Métropole - Eau - PDF", id: "lemansmetropoleeaupdf" },
    { name: "Lucia - Electricité - PDF", id: "luciaelectricitypdf" },
    { name: "Octopus - Electricité - PDF", id: "octopuselectricitypdf" },
    { name: "Priméo - Electricité - CSV", id: "primeoelectricitycsv" },
    { name: "Proxelia - Electricité - PDF", id: "proxeliaelectricitypdf" },
    { name: "Regaz - Gaz - CSV - Import", id: "regazgascsv" },
    { name: "Save - Gaz - XLSX", id: "savegazxlsx" },
    { name: "Selfee - Electricité - CSV", id: "selfeeelectricitycsv" },
    { name: "Selfee - Electricité - PDF - Piece jointe de facture", id: "selfeeelectricitybilllink" },
    { name: "Seop - Eau - PDF", id: "seopwaterpdf" },
    { name: "Suez - Eau - PDF", id: "suezwaterpdf" },
    { name: "Total (C2,C3,C4) - Electricité - PDF", id: "totalelectricitypdf" },
    { name: "Total Direct Energie - Electricité - PDF", id: "totaldeelectricitypdf" },
    { name: "Total Direct Energie - Gaz - PDF", id: "totaldegaspdf" },
    { name: "Total Electricité Entreprises - Electricité - PDF", id: "totalentrepriselectricitypdf" },
    { name: "Total Gaz Entreprises - Gaz - PDF", id: "totalentreprisegaspdf" },
    { name: "Total DirectView - Electricité - XLSX/CSV", id: "totaldirectviewelectricityxlsx" },
    { name: "Total DirectView - Gaz - XLSX", id: "totaldirectviewgasxlsx" },
    { name: "Véolia - Eau - PDF", id: "veoliawaterpdf" },
    { name: "Véolia Artois - Eau - PDF", id: "veoliaartoiswaterpdf" },
    { name: "Véolia SEDIF - Eau - PDF", id: "veoliasedifwaterpdf" },
    { name: "Verseo - Chaleur - PDF", id: "verseoheatpdf" },
    { name: "Volterres - Electricité - XLSX", id: "volterreselectricityxlsx" },
  ];

  export { archiData, billData };